import { Component } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { BaseFormFieldComponent } from "../base-form-field.component";

@Component({
  selector: "rc-multi-line-string-form-field",
  templateUrl: "./multi-line-string-form-field.component.html",
  styleUrls: ["./multi-line-string-form-field.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: MultiLineStringFormFieldComponent,
    },
  ],
  standalone: false,
})
export class MultiLineStringFormFieldComponent extends BaseFormFieldComponent<string | number> {
  public constructor() {
    super();
  }

  public async onInputChange(event: unknown) {
    const ionEvent = event as CustomEvent;

    const inputValue = ionEvent.detail.value;
    if (ionEvent.type !== "ionChange" || this.readOnlyValue === inputValue) {
      return;
    }

    await this.onInputChangeInternal(inputValue);
  }

  protected toDisplayValue(input: string | number): string {
    return input?.toString();
  }
}
